import * as React from 'react';
import styles from './index.less';
// import {Modal} from "antd";
import { history } from '@@/core/history';
import FNoDataTip from '@/components/FNoDataTip';
import { FUtil } from '@freelog/tools-lib';

interface Error404Props {

}

function Error404({}: Error404Props) {

  return (<div>
    <FNoDataTip
      height={'calc(100vh - 70px)'}
      tipText={'404,页面不见了'}
      btnText={'将前往首页'}
      onClick={() => {
        history.replace(FUtil.LinkTo.market());
      }}
    />
  </div>);
}

export default Error404;
